import GridCardFormatter from 'crm-cards-sdk/card-formatters/GridCardFormatter';
import ExternalTitleCardFormatter from 'crm-cards-sdk/card-formatters/ExternalTitleCardFormatter';
import { useMemo } from 'react';
import CollapsibleCardFormatterWithAPI from '../internal/cardFormatterDecorators/CollapsibleCardFormatterWithAPI';
import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { createContainerContentKey } from './createContainerContentKey';
import { useTheme } from 'foundations-theming/utils';
import LinkCardActionButtonList from 'crm-cards-sdk/action-formatters/LinkCardActionButtonList';

// default to half width
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_GRID_ITEM_SIZE = 6;
const MIN_GRID_ITEM_WIDTH_PX = '400px';
const getGridItemSize = gridItem => {
  var _gridItem$layout, _gridItem$layout2;
  if ((_gridItem$layout = gridItem.layout) !== null && _gridItem$layout !== void 0 && _gridItem$layout.widthInGrid) {
    return gridItem.layout.widthInGrid;
  }

  // This is legacy behavior, the inParent should be going away.
  if (gridItem.type === 'CONTAINER' && (_gridItem$layout2 = gridItem.layout) !== null && _gridItem$layout2 !== void 0 && (_gridItem$layout2 = _gridItem$layout2.inParent) !== null && _gridItem$layout2 !== void 0 && _gridItem$layout2.gridItemSize) {
    return gridItem.layout.inParent.gridItemSize;
  }
  return DEFAULT_GRID_ITEM_SIZE;
};
function getIdealGridItemPercentWidth(gridItem, gap) {
  const gridItemSize = getGridItemSize(gridItem);
  const percentWidth = `${gridItemSize / 12 * 100}%`;
  // We need to subtract the gap from the percent width to get the ideal width of the grid item.
  // we also need to ensure that the grid item is at least the minimum px width so we don't
  // have two cards on the same line when the width is very small
  return `max(calc(${percentWidth} - ${gap}), ${MIN_GRID_ITEM_WIDTH_PX})`;
}
function GridContainerFormatter({
  containerId,
  contents,
  CrmContainerContentRenderer,
  layout,
  observerManager,
  CardFormatter
}) {
  const theme = useTheme();
  const DefaultCardFormatter = useMemo(() => {
    if (CardFormatter) {
      return CardFormatter;
    }
    if (layout.use === 'collapsible-cards') {
      return CollapsibleCardFormatterWithAPI;
    }
    if (layout.use === 'external-title') {
      return ExternalTitleCardFormatter;
    }
    return GridCardFormatter;
  }, [CardFormatter, layout.use]);
  return /*#__PURE__*/_jsx(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter,
      reorderable: false,
      observerManager,
      ActionFormatter: LinkCardActionButtonList
    },
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      inlineSize: "100%",
      flexWrap: "wrap",
      gap: "400",
      paddingBlockEnd: "400",
      children: contents.map(gridItem => {
        return /*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: getIdealGridItemPercentWidth(gridItem, theme.space['400']),
          minInlineSize: getIdealGridItemPercentWidth(gridItem, theme.space['400']),
          children: /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
            content: gridItem
          })
        }, createContainerContentKey(containerId, gridItem));
      })
    })
  });
}
export default GridContainerFormatter;